<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div>
          <div class="btn" @click="handleModal('add')">+ 新增标签项</div>
        </div>
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          border
          highlight-current-row
          :header-cell-style="{
            color: '#333',
            background: '#FAFAFA',
            borderBottom: '1px solid #E8E8E8',
            height: '44px',
          }"
          :row-style="{
            height: '44px',
          }"
        >
          <!-- <el-table-column
            prop="created"
            align="center"
            label="日期"
            width="180px"
          ></el-table-column> -->
          <el-table-column
            prop="labelName"
            align="center"
            label="展示值"
          ></el-table-column>
          <el-table-column prop="pic" align="center" label="图片">
            <div slot-scope="scope">
              <el-image
                class="brand-pic"
                v-if="scope.row.pic"
                style="width: 36px;height: 36px;"
                :src="scope.row.pic"
                :preview-src-list="[scope.row.pic]"
              >
              </el-image>
            </div>
          </el-table-column>
          <!-- <el-table-column
            prop="value"
            align="center"
            label="标签值"
          ></el-table-column> -->
          <el-table-column prop="detailOpen" align="center" label="启用状态">
            <div slot-scope="scope">
              {{ openMap[scope.row.detailOpen] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="detailDesc"
            align="center"
            label="描述"
            width="600"
          >
            <div slot-scope="scope">
              <div v-html="scope.row.detailDesc" class="desc-box"></div>
            </div>
          </el-table-column>
          <el-table-column prop="open" align="center" label="设为筛选条件">
            <div
              slot-scope="scope"
              @click="
                changeLabelItemFilter(scope.row.id, scope.row.detailFilter)
              "
            >
              <i
                v-if="scope.row.detailFilter === 1"
                class="iconfont icon-xuanzye checked-icon"
                style="color: #6B95FF;"
              ></i>
              <i v-else class="iconfont icon-weixzye"></i>
              {{ scope.row.detailFilter === 1 ? "是" : "否" }}
            </div>
          </el-table-column>
          <el-table-column prop="open" align="center" label="设为推荐分类">
            <div
              slot-scope="scope"
              @click="
                changeLabelItemRecommend(
                  scope.row.id,
                  scope.row.detailRecommend
                )
              "
            >
              <i
                v-if="scope.row.detailRecommend === 1"
                class="iconfont icon-xuanzye checked-icon"
                style="color: #6B95FF;"
              ></i>
              <i v-else class="iconfont icon-weixzye"></i>
              {{ scope.row.detailRecommend === 1 ? "是" : "否" }}
            </div>
          </el-table-column>
          <el-table-column
            prop="detailSort"
            align="center"
            label="排序标记"
          ></el-table-column>
          <el-table-column prop="detailLock" align="center" label="控制锁">
            <div slot-scope="scope">
              {{ lockMap[scope.row.detailLock] }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                class="table-btn"
                @click="handleModal('edit', scope.row)"
              >
                变更
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="handleDelete(scope.row.id)"
              >
                删除
              </button>
              <button
                size="mini"
                v-if="scope.row.detailLock === 1"
                class="table-btn"
                @click="handleLock(scope.row.id)"
              >
                控制锁
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="visible" class="dialog" width="800px" top="5vh">
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "新增" : "变更") + "标签项" }}
      </div>
      <el-form ref="form" :model="form" class="form" label-width="auto">
        <el-form-item label="展示值：" prop="labelName" class="form-item">
          <el-input
            size="small"
            placeholder="请输入展示值"
            v-model="form.labelName"
          ></el-input>
        </el-form-item>
        <el-form-item class="img_item" prop="pic" label="图片：">
          <div class="addImg">
            <p class="tips">推荐大小400px*400px</p>
            <div class="img-box">
              <img ref="img" :src="form.pic" v-if="form.pic" />
              <div class="icon" v-else>
                <p><i class="el-icon-plus" style="font-size: 24px"></i></p>
                <p>图片</p>
                <p class="tip">支持扩展名：.jpg .png</p>
              </div>
              <input
                type="file"
                class="file"
                ref="inputImg"
                accept="image/png, image/jpg, image/jpeg"
                @change="addChangeImg"
              />
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="标签项值：" prop="value" class="form-item">
          <el-input
            size="small"
            placeholder="请输入标签项值"
            v-model="form.value"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="启用状态：" prop="detailOpen" class="form-item">
          <el-switch
            v-model="form.detailOpen"
            :active-value="1"
            :inactive-value="2"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="描述：" prop="desc" class="form-item">
          <!-- <el-input
            size="small"
            placeholder="描述"
            type="textarea"
            :rows="5"
            v-model="form.detailDesc"
          ></el-input> -->
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="defaultConfig"
            mode="simple"
          />
          <Editor
            style="overflow-y: hidden;border: 1px solid #DCDFE6;height: 200px;"
            v-model="form.detailDesc"
            @onCreated="onCreated"
            :defaultConfig="defaultConfig"
            mode="simple"
          />
        </el-form-item>
        <el-form-item label="排序标记：" prop="detailSort" class="form-item">
          <el-input-number
            v-model="form.detailSort"
            label="排序标记"
            :step="1"
            step-strictly
            style="width: 140px;"
            size="small"
            placeholder="排序标记"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import WangEditor from 'wangeditor';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
export default {
  components: {
    Header,
    Editor,
    Toolbar
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '标签项设置'
      },
      openMap: {
        1: '是',
        2: '否'
      },
      lockMap: {
        1: '未开启',
        2: '已开启，该项不能随意修改',
      },
      list: [],
      total: 0,
      type: '',
      visible: false,
      form: {
        labelName: '',
        // value: '',
        pic: '',
        detailSort: null,
        detailOpen: 1,
        detailDesc: '',
        detailFilter: 1,
        detailRecommend: 1
      },
      id: null,
      editor: null,
      defaultConfig: {
        toolbarKeys: [
          'fontSize',
          'bold',
          'color',
          'italic'
        ]
      }
    };
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  computed: {},
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onChange(editor){
      // console.log(editor.getHtml());
      this.$emit('change', editor.getHtml()); // 将内容同步到父组件中
    },
    // 获取轮播列表
    getList() {
      this.loading++;
      this.httpGet(this.$root.getLabelItem, {
        id: this.$route.query.id || '',
        dataName: this.$route.query.dataName || '',
      }).then(
        (res) => {
          this.loading--;
          this.list = res;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleModal(type, rowData) {
      this.type = type;
      if (type === 'edit') {
        this.id = rowData.id;
        this.form = {
          labelName: rowData.labelName,
          pic: rowData.pic,
          // value: rowData.value,
          detailSort: rowData.detailSort,
          detailOpen: rowData.detailOpen,
          detailDesc: rowData.detailDesc
        };
      } else {
        this.form = {
          labelName: '',
          pic: '',
          // value: '',
          detailSort: '',
          detailOpen: 1,
          detailDesc: ''
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.visible = true;
    },
    changeLabelItemFilter(id, detailFilter) {
      let str = '';
      if(detailFilter === 1){
        str = '取消';
      }
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>是否${str}设置该标签项为筛选条件？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.changeLabelItemFilter, {
          id,
          detailFilter: detailFilter === 1 ? 2 : 1
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    changeLabelItemRecommend(id, detailRecommend) {
      let str = '';
      if(detailRecommend === 1){
        str = '取消';
      }
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>是否${str}设置该标签为推荐分类？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.changeLabelItemRecommend, {
          id,
          detailRecommend: detailRecommend === 1 ? 2 : 1
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 删除轮播图
    handleDelete(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该标签项吗?</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteLabelItem, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleLock(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确认后,该项数据不能更改,且操作不可逆, 确认锁定吗?</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.lockLabelItem, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.form, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    },
    // 轮播
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url =
            this.type === 'add'
              ? this.$root.addLabelItem
              : this.$root.updateLabelItem;
          let method = this.type === 'add' ? 'httpPost' : 'httpPut';
          let inputData =
            this.type === 'add'
              ? {
                  ...this.form,
                  fid: +this.$route.query.id,
                  firstDataName: this.$route.query.dataName
                }
              : {
                  ...this.form,
                  id: this.id
                };
          this.loading++;
          this[method](url, inputData).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.visible = false;
              this.getList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    }
  }
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    // content 表格
    .content {
      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      .table-img {
        height: 70px;
        width: auto;
      }

      .desc-box{
        text-align: left;
        font-size: 14px;
        p{
          font-size: 14px !important;
        }
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .form {
    padding: 12px 24px;

    .addImg {
      .icon {
        width: 160px;
        height: 160px;
      }
      img{
        height: 160px;
        width: auto;
      }
    }

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
